export default "//file.bilionpass.com/japandx-web/0.0.1/static/icon_discount_food.870f515d-abfc30.svg";